export interface CountryCode {
  alphaTwo: string;
  alphaThree: string;
  numeric: string;
}

export const countryCodes: Record<string, CountryCode> = {
  AUSTRALIA: { alphaTwo: 'AU', alphaThree: 'AUS', numeric: '036' },
  AUSTRIA: { alphaTwo: 'AT', alphaThree: 'AUT', numeric: '040' },
  BAHRAIN: { alphaTwo: 'BH', alphaThree: 'BHR', numeric: '048' },
  BARBADOS: { alphaTwo: 'BB', alphaThree: 'BRB', numeric: '052' },
  BELGIUM: { alphaTwo: 'BE', alphaThree: 'BEL', numeric: '056' },
  BOTSWANA: { alphaTwo: 'BW', alphaThree: 'BWA', numeric: '072' },
  BRAZIL: { alphaTwo: 'BR', alphaThree: 'BRA', numeric: '076' },
  BRUNEI_DARUSSALAM: { alphaTwo: 'BN', alphaThree: 'BRN', numeric: '096' },
  BULGARIA: { alphaTwo: 'BG', alphaThree: 'BGR', numeric: '100' },
  CAMBODIA: { alphaTwo: 'KH', alphaThree: 'KHM', numeric: '116' },
  CANADA: { alphaTwo: 'CA', alphaThree: 'CAN', numeric: '124' },
  CHILE: { alphaTwo: 'CL', alphaThree: 'CHL', numeric: '152' },
  CHINA: { alphaTwo: 'CN', alphaThree: 'CHN', numeric: '156' },
  CROATIA: { alphaTwo: 'HR', alphaThree: 'HRV', numeric: '191' },
  CYPRUS: { alphaTwo: 'CY', alphaThree: 'CYP', numeric: '196' },
  CZECH_REPUBLIC: { alphaTwo: 'CZ', alphaThree: 'CZE', numeric: '203' },
  DENMARK: { alphaTwo: 'DK', alphaThree: 'DNK', numeric: '208' },
  DOMINICA: { alphaTwo: 'DM', alphaThree: 'DMA', numeric: '212' },
  ESTONIA: { alphaTwo: 'EE', alphaThree: 'EST', numeric: '233' },
  FINLAND: { alphaTwo: 'FI', alphaThree: 'FIN', numeric: '246' },
  FRANCE: { alphaTwo: 'FR', alphaThree: 'FRA', numeric: '250' },
  GERMANY: { alphaTwo: 'DE', alphaThree: 'DEU', numeric: '276' },
  GREECE: { alphaTwo: 'GR', alphaThree: 'GRC', numeric: '300' },
  HONG_KONG: { alphaTwo: 'HK', alphaThree: 'HKG', numeric: '344' },
  HUNGARY: { alphaTwo: 'HU', alphaThree: 'HUN', numeric: '348' },
  ICELAND: { alphaTwo: 'IS', alphaThree: 'ISL', numeric: '352' },
  INDONESIA: { alphaTwo: 'ID', alphaThree: 'IDN', numeric: '360' },
  IRELAND: { alphaTwo: 'IE', alphaThree: 'IRL', numeric: '372' },
  ITALY: { alphaTwo: 'IT', alphaThree: 'ITA', numeric: '380' },
  JAPAN: { alphaTwo: 'JP', alphaThree: 'JPN', numeric: '392' },
  KAZAKHSTAN: { alphaTwo: 'KZ', alphaThree: 'KAZ', numeric: '398' },
  SOUTH_KOREA: { alphaTwo: 'KR', alphaThree: 'KOR', numeric: '410' },
  KUWAIT: { alphaTwo: 'KW', alphaThree: 'KWT', numeric: '414' },
  LATVIA: { alphaTwo: 'LV', alphaThree: 'LVA', numeric: '428' },
  LIECHTENSTEIN: { alphaTwo: 'LI', alphaThree: 'LIE', numeric: '438' },
  LITHUANIA: { alphaTwo: 'LT', alphaThree: 'LTU', numeric: '440' },
  LUXEMBOURG: { alphaTwo: 'LU', alphaThree: 'LUX', numeric: '442' },
  MACAU: { alphaTwo: 'MO', alphaThree: 'MAC', numeric: '446' },
  MALAYSIA: { alphaTwo: 'MY', alphaThree: 'MYS', numeric: '458' },
  MALTA: { alphaTwo: 'MT', alphaThree: 'MLT', numeric: '470' },
  MAURITIUS: { alphaTwo: 'MU', alphaThree: 'MUS', numeric: '480' },
  MEXICO: { alphaTwo: 'MX', alphaThree: 'MEX', numeric: '484' },
  NETHERLANDS: { alphaTwo: 'NL', alphaThree: 'NLD', numeric: '528' },
  NEW_ZEALAND: { alphaTwo: 'NZ', alphaThree: 'NZL', numeric: '554' },
  NORWAY: { alphaTwo: 'NO', alphaThree: 'NOR', numeric: '578' },
  OMAN: { alphaTwo: 'OM', alphaThree: 'OMN', numeric: '512' },
  PERU: { alphaTwo: 'PE', alphaThree: 'PER', numeric: '604' },
  POLAND: { alphaTwo: 'PL', alphaThree: 'POL', numeric: '616' },
  PORTUGAL: { alphaTwo: 'PT', alphaThree: 'PRT', numeric: '620' },
  QATAR: { alphaTwo: 'QA', alphaThree: 'QAT', numeric: '634' },
  ROMANIA: { alphaTwo: 'RO', alphaThree: 'ROU', numeric: '642' },
  SINGAPORE: { alphaTwo: 'SG', alphaThree: 'SGP', numeric: '702' },
  SLOVAKIA: { alphaTwo: 'SK', alphaThree: 'SVK', numeric: '703' },
  SLOVENIA: { alphaTwo: 'SI', alphaThree: 'SVN', numeric: '705' },
  SPAIN: { alphaTwo: 'ES', alphaThree: 'ESP', numeric: '724' },
  SWEDEN: { alphaTwo: 'SE', alphaThree: 'SWE', numeric: '752' },
  SWITZERLAND: { alphaTwo: 'CH', alphaThree: 'CHE', numeric: '756' },
  TAIWAN: { alphaTwo: 'TW', alphaThree: 'TWN', numeric: '158' },
  THAILAND: { alphaTwo: 'TH', alphaThree: 'THA', numeric: '764' },
  TUNISIA: { alphaTwo: 'TN', alphaThree: 'TUN', numeric: '788' },
  UNITED_ARAB_EMIRATES: { alphaTwo: 'AE', alphaThree: 'ARE', numeric: '784' },
  UNITED_STATES_OF_AMERICA: { alphaTwo: 'US', alphaThree: 'USA', numeric: '840' },
  SERBIA: { alphaTwo: 'RS', alphaThree: 'SRB', numeric: '688' },
  AFGHANISTAN: { alphaTwo: 'AF', alphaThree: 'AFG', numeric: '004' },
  ALBANIA: { alphaTwo: 'AL', alphaThree: 'ALB', numeric: '008' },
  ALGERIA: { alphaTwo: 'DZ', alphaThree: 'DZA', numeric: '012' },
  AMERICAN_SAMOA: { alphaTwo: 'AS', alphaThree: 'ASM', numeric: '016' },
  ANDORRA: { alphaTwo: 'AD', alphaThree: 'AND', numeric: '020' },
  ANGOLA: { alphaTwo: 'AO', alphaThree: 'AGO', numeric: '024' },
  ANGUILLA: { alphaTwo: 'AI', alphaThree: 'AIA', numeric: '660' },
  ANTARCTICA: { alphaTwo: 'AQ', alphaThree: 'ATA', numeric: '010' },
  ANTIGUA_AND_BARBUDA: { alphaTwo: 'AG', alphaThree: 'ATG', numeric: '028' },
  ARGENTINA: { alphaTwo: 'AR', alphaThree: 'ARG', numeric: '032' },
  ARMENIA: { alphaTwo: 'AM', alphaThree: 'ARM', numeric: '051' },
  ARUBA: { alphaTwo: 'AW', alphaThree: 'ABW', numeric: '533' },
  AZERBAIJAN: { alphaTwo: 'AZ', alphaThree: 'AZE', numeric: '031' },
  BAHAMAS: { alphaTwo: 'BS', alphaThree: 'BHS', numeric: '044' },
  BANGLADESH: { alphaTwo: 'BD', alphaThree: 'BGD', numeric: '050' },
  BELARUS: { alphaTwo: 'BY', alphaThree: 'BLR', numeric: '112' },
  BELIZE: { alphaTwo: 'BZ', alphaThree: 'BLZ', numeric: '084' },
  BENIN: { alphaTwo: 'BJ', alphaThree: 'BEN', numeric: '204' },
  BERMUDA: { alphaTwo: 'BM', alphaThree: 'BMU', numeric: '060' },
  BHUTAN: { alphaTwo: 'BT', alphaThree: 'BTN', numeric: '064' },
  BOLIVIA: { alphaTwo: 'BO', alphaThree: 'BOL', numeric: '068' },
  BOSNIA_AND_HERZEGOVINA: { alphaTwo: 'BA', alphaThree: 'BIH', numeric: '070' },
  BOUVET_ISLAND: { alphaTwo: 'BV', alphaThree: 'BVT', numeric: '074' },
  BRITISH_INDIAN_OCEAN_TERRITORY: { alphaTwo: 'IO', alphaThree: 'IOT', numeric: '086' },
  BURKINA_FASO: { alphaTwo: 'BF', alphaThree: 'BFA', numeric: '854' },
  BURUNDI: { alphaTwo: 'BI', alphaThree: 'BDI', numeric: '108' },
  CAMEROON: { alphaTwo: 'CM', alphaThree: 'CMR', numeric: '120' },
  CAPE_VERDE: { alphaTwo: 'CV', alphaThree: 'CPV', numeric: '132' },
  CAYMAN_ISLANDS: { alphaTwo: 'KY', alphaThree: 'CYM', numeric: '136' },
  CENTRAL_AFRICAN_REPUBLIC: { alphaTwo: 'CF', alphaThree: 'CAF', numeric: '140' },
  CHAD: { alphaTwo: 'TD', alphaThree: 'TCD', numeric: '148' },
  CHRISTMAS_ISLAND: { alphaTwo: 'CX', alphaThree: 'CXR', numeric: '162' },
  COCOS_KEELING_ISLANDS: { alphaTwo: 'CC', alphaThree: 'CCK', numeric: '166' },
  COLOMBIA: { alphaTwo: 'CO', alphaThree: 'COL', numeric: '170' },
  COMOROS: { alphaTwo: 'KM', alphaThree: 'COM', numeric: '174' },
  CONGO: { alphaTwo: 'CG', alphaThree: 'COG', numeric: '178' },
  CONGO_THE_DEMOCRATIC_REPUBLIC_OF_THE: { alphaTwo: 'CD', alphaThree: 'COD', numeric: '180' },
  COOK_ISLANDS: { alphaTwo: 'CK', alphaThree: 'COK', numeric: '184' },
  COSTA_RICA: { alphaTwo: 'CR', alphaThree: 'CRI', numeric: '188' },
  COTE_DIVOIRE: { alphaTwo: 'CI', alphaThree: 'CIV', numeric: '384' },
  CUBA: { alphaTwo: 'CU', alphaThree: 'CUB', numeric: '192' },
  DJIBOUTI: { alphaTwo: 'DJ', alphaThree: 'DJI', numeric: '262' },
  DOMINICAN_REPUBLIC: { alphaTwo: 'DO', alphaThree: 'DOM', numeric: '214' },
  ECUADOR: { alphaTwo: 'EC', alphaThree: 'ECU', numeric: '218' },
  EGYPT: { alphaTwo: 'EG', alphaThree: 'EGY', numeric: '818' },
  EL_SALVADOR: { alphaTwo: 'SV', alphaThree: 'SLV', numeric: '222' },
  EQUATORIAL_GUINEA: { alphaTwo: 'GQ', alphaThree: 'GNQ', numeric: '226' },
  ERITREA: { alphaTwo: 'ER', alphaThree: 'ERI', numeric: '232' },
  ETHIOPIA: { alphaTwo: 'ET', alphaThree: 'ETH', numeric: '231' },
  FALKLAND_ISLANDS_MALVINAS: { alphaTwo: 'FK', alphaThree: 'FLK', numeric: '238' },
  FAROE_ISLANDS: { alphaTwo: 'FO', alphaThree: 'FRO', numeric: '234' },
  FIJI: { alphaTwo: 'FJ', alphaThree: 'FJI', numeric: '242' },
  FRENCH_GUIANA: { alphaTwo: 'GF', alphaThree: 'GUF', numeric: '254' },
  FRENCH_POLYNESIA: { alphaTwo: 'PF', alphaThree: 'PYF', numeric: '258' },
  FRENCH_SOUTHERN_TERRITORIES: { alphaTwo: 'TF', alphaThree: 'ATF', numeric: '260' },
  GABON: { alphaTwo: 'GA', alphaThree: 'GAB', numeric: '266' },
  GAMBIA: { alphaTwo: 'GM', alphaThree: 'GMB', numeric: '270' },
  GEORGIA: { alphaTwo: 'GE', alphaThree: 'GEO', numeric: '268' },
  GHANA: { alphaTwo: 'GH', alphaThree: 'GHA', numeric: '288' },
  GIBRALTAR: { alphaTwo: 'GI', alphaThree: 'GIB', numeric: '292' },
  GREENLAND: { alphaTwo: 'GL', alphaThree: 'GRL', numeric: '304' },
  GRENADA: { alphaTwo: 'GD', alphaThree: 'GRD', numeric: '308' },
  GUADELOUPE: { alphaTwo: 'GP', alphaThree: 'GLP', numeric: '312' },
  GUAM: { alphaTwo: 'GU', alphaThree: 'GUM', numeric: '316' },
  GUATEMALA: { alphaTwo: 'GT', alphaThree: 'GTM', numeric: '320' },
  GUINEA: { alphaTwo: 'GN', alphaThree: 'GIN', numeric: '324' },
  GUINEA_BISSAU: { alphaTwo: 'GW', alphaThree: 'GNB', numeric: '624' },
  GUYANA: { alphaTwo: 'GY', alphaThree: 'GUY', numeric: '328' },
  HAITI: { alphaTwo: 'HT', alphaThree: 'HTI', numeric: '332' },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: { alphaTwo: 'HM', alphaThree: 'HMD', numeric: '334' },
  VATICAN: { alphaTwo: 'VA', alphaThree: 'VAT', numeric: '336' },
  HONDURAS: { alphaTwo: 'HN', alphaThree: 'HND', numeric: '340' },
  INDIA: { alphaTwo: 'IN', alphaThree: 'IND', numeric: '356' },
  IRAN_ISLAMIC_REPUBLIC_OF: { alphaTwo: 'IR', alphaThree: 'IRN', numeric: '364' },
  IRAQ: { alphaTwo: 'IQ', alphaThree: 'IRQ', numeric: '368' },
  ISRAEL: { alphaTwo: 'IL', alphaThree: 'ISR', numeric: '376' },
  JAMAICA: { alphaTwo: 'JM', alphaThree: 'JAM', numeric: '388' },
  JORDAN: { alphaTwo: 'JO', alphaThree: 'JOR', numeric: '400' },
  KENYA: { alphaTwo: 'KE', alphaThree: 'KEN', numeric: '404' },
  KIRIBATI: { alphaTwo: 'KI', alphaThree: 'KIR', numeric: '296' },
  NORTH_KOREA: { alphaTwo: 'KP', alphaThree: 'PRK', numeric: '408' },
  KYRGYZSTAN: { alphaTwo: 'KG', alphaThree: 'KGZ', numeric: '417' },
  LAOS: { alphaTwo: 'LA', alphaThree: 'LAO', numeric: '418' },
  LEBANON: { alphaTwo: 'LB', alphaThree: 'LBN', numeric: '422' },
  LESOTHO: { alphaTwo: 'LS', alphaThree: 'LSO', numeric: '426' },
  LIBERIA: { alphaTwo: 'LR', alphaThree: 'LBR', numeric: '430' },
  LIBYA: { alphaTwo: 'LY', alphaThree: 'LBY', numeric: '434' },
  MADAGASCAR: { alphaTwo: 'MG', alphaThree: 'MDG', numeric: '450' },
  MALAWI: { alphaTwo: 'MW', alphaThree: 'MWI', numeric: '454' },
  MALDIVES: { alphaTwo: 'MV', alphaThree: 'MDV', numeric: '462' },
  MALI: { alphaTwo: 'ML', alphaThree: 'MLI', numeric: '466' },
  MARSHALL_ISLANDS: { alphaTwo: 'MH', alphaThree: 'MHL', numeric: '584' },
  MARTINIQUE: { alphaTwo: 'MQ', alphaThree: 'MTQ', numeric: '474' },
  MAURITANIA: { alphaTwo: 'MR', alphaThree: 'MRT', numeric: '478' },
  MAYOTTE: { alphaTwo: 'YT', alphaThree: 'MYT', numeric: '175' },
  MICRONESIA_FEDERATED_STATES_OF: { alphaTwo: 'FM', alphaThree: 'FSM', numeric: '583' },
  MOLDOVA_REPUBLIC_OF: { alphaTwo: 'MD', alphaThree: 'MDA', numeric: '498' },
  MONACO: { alphaTwo: 'MC', alphaThree: 'MCO', numeric: '492' },
  MONGOLIA: { alphaTwo: 'MN', alphaThree: 'MNG', numeric: '496' },
  MONTSERRAT: { alphaTwo: 'MS', alphaThree: 'MSR', numeric: '500' },
  MOROCCO: { alphaTwo: 'MA', alphaThree: 'MAR', numeric: '504' },
  MOZAMBIQUE: { alphaTwo: 'MZ', alphaThree: 'MOZ', numeric: '508' },
  MYANMAR: { alphaTwo: 'MM', alphaThree: 'MMR', numeric: '104' },
  NAMIBIA: { alphaTwo: 'NA', alphaThree: 'NAM', numeric: '516' },
  NAURU: { alphaTwo: 'NR', alphaThree: 'NRU', numeric: '520' },
  NEPAL: { alphaTwo: 'NP', alphaThree: 'NPL', numeric: '524' },
  NEW_CALEDONIA: { alphaTwo: 'NC', alphaThree: 'NCL', numeric: '540' },
  NICARAGUA: { alphaTwo: 'NI', alphaThree: 'NIC', numeric: '558' },
  NIGER: { alphaTwo: 'NE', alphaThree: 'NER', numeric: '562' },
  NIGERIA: { alphaTwo: 'NG', alphaThree: 'NGA', numeric: '566' },
  NIUE: { alphaTwo: 'NU', alphaThree: 'NIU', numeric: '570' },
  NORFOLK_ISLAND: { alphaTwo: 'NF', alphaThree: 'NFK', numeric: '574' },
  NORTH_MACEDONIA_REPUBLIC_OF: { alphaTwo: 'MK', alphaThree: 'MKD', numeric: '807' },
  NORTHERN_MARIANA_ISLANDS: { alphaTwo: 'MP', alphaThree: 'MNP', numeric: '580' },
  PAKISTAN: { alphaTwo: 'PK', alphaThree: 'PAK', numeric: '586' },
  PALAU: { alphaTwo: 'PW', alphaThree: 'PLW', numeric: '585' },
  PALESTINE: { alphaTwo: 'PS', alphaThree: 'PSE', numeric: '275' },
  PANAMA: { alphaTwo: 'PA', alphaThree: 'PAN', numeric: '591' },
  PAPUA_NEW_GUINEA: { alphaTwo: 'PG', alphaThree: 'PNG', numeric: '598' },
  PARAGUAY: { alphaTwo: 'PY', alphaThree: 'PRY', numeric: '600' },
  PHILIPPINES: { alphaTwo: 'PH', alphaThree: 'PHL', numeric: '608' },
  PITCAIRN: { alphaTwo: 'PN', alphaThree: 'PCN', numeric: '612' },
  PUERTO_RICO: { alphaTwo: 'PR', alphaThree: 'PRI', numeric: '630' },
  REUNION: { alphaTwo: 'RE', alphaThree: 'REU', numeric: '638' },
  RUSSIA: { alphaTwo: 'RU', alphaThree: 'RUS', numeric: '643' },
  RWANDA: { alphaTwo: 'RW', alphaThree: 'RWA', numeric: '646' },
  SAINT_HELENA: { alphaTwo: 'SH', alphaThree: 'SHN', numeric: '654' },
  SAINT_KITTS_AND_NEVIS: { alphaTwo: 'KN', alphaThree: 'KNA', numeric: '659' },
  SAINT_LUCIA: { alphaTwo: 'LC', alphaThree: 'LCA', numeric: '662' },
  SAINT_PIERRE_AND_MIQUELON: { alphaTwo: 'PM', alphaThree: 'SPM', numeric: '666' },
  SAINT_VINCENT_AND_THE_GRENADINES: { alphaTwo: 'VC', alphaThree: 'VCT', numeric: '670' },
  SAMOA: { alphaTwo: 'WS', alphaThree: 'WSM', numeric: '882' },
  SAN_MARINO: { alphaTwo: 'SM', alphaThree: 'SMR', numeric: '674' },
  SAO_TOME_AND_PRINCIPE: { alphaTwo: 'ST', alphaThree: 'STP', numeric: '678' },
  SAUDI_ARABIA: { alphaTwo: 'SA', alphaThree: 'SAU', numeric: '682' },
  SENEGAL: { alphaTwo: 'SN', alphaThree: 'SEN', numeric: '686' },
  SEYCHELLES: { alphaTwo: 'SC', alphaThree: 'SYC', numeric: '690' },
  SIERRA_LEONE: { alphaTwo: 'SL', alphaThree: 'SLE', numeric: '694' },
  SOLOMON_ISLANDS: { alphaTwo: 'SB', alphaThree: 'SLB', numeric: '090' },
  SOMALIA: { alphaTwo: 'SO', alphaThree: 'SOM', numeric: '706' },
  SOUTH_AFRICA: { alphaTwo: 'ZA', alphaThree: 'ZAF', numeric: '710' },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: { alphaTwo: 'GS', alphaThree: 'SGS', numeric: '239' },
  SRI_LANKA: { alphaTwo: 'LK', alphaThree: 'LKA', numeric: '144' },
  SUDAN: { alphaTwo: 'SD', alphaThree: 'SDN', numeric: '729' },
  SURINAME: { alphaTwo: 'SR', alphaThree: 'SUR', numeric: '740' },
  SVALBARD_AND_JAN_MAYEN: { alphaTwo: 'SJ', alphaThree: 'SJM', numeric: '744' },
  SWAZILAND: { alphaTwo: 'SZ', alphaThree: 'SWZ', numeric: '748' },
  SYRIA: { alphaTwo: 'SY', alphaThree: 'SYR', numeric: '760' },
  TAJIKISTAN: { alphaTwo: 'TJ', alphaThree: 'TJK', numeric: '762' },
  TANZANIA_UNITED_REPUBLIC_OF: { alphaTwo: 'TZ', alphaThree: 'TZA', numeric: '834' },
  TIMOR_LESTE: { alphaTwo: 'TL', alphaThree: 'TLS', numeric: '626' },
  TOGO: { alphaTwo: 'TG', alphaThree: 'TGO', numeric: '768' },
  TOKELAU: { alphaTwo: 'TK', alphaThree: 'TKL', numeric: '772' },
  TONGA: { alphaTwo: 'TO', alphaThree: 'TON', numeric: '776' },
  TRINIDAD_AND_TOBAGO: { alphaTwo: 'TT', alphaThree: 'TTO', numeric: '780' },
  TURKEY: { alphaTwo: 'TR', alphaThree: 'TUR', numeric: '792' },
  TURKMENISTAN: { alphaTwo: 'TM', alphaThree: 'TKM', numeric: '795' },
  TURKS_AND_CAICOS_ISLANDS: { alphaTwo: 'TC', alphaThree: 'TCA', numeric: '796' },
  TUVALU: { alphaTwo: 'TV', alphaThree: 'TUV', numeric: '798' },
  UGANDA: { alphaTwo: 'UG', alphaThree: 'UGA', numeric: '800' },
  UKRAINE: { alphaTwo: 'UA', alphaThree: 'UKR', numeric: '804' },
  UNITED_KINGDOM: { alphaTwo: 'GB', alphaThree: 'GBR', numeric: '826' },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: { alphaTwo: 'UM', alphaThree: 'UMI', numeric: '581' },
  URUGUAY: { alphaTwo: 'UY', alphaThree: 'URY', numeric: '858' },
  UZBEKISTAN: { alphaTwo: 'UZ', alphaThree: 'UZB', numeric: '860' },
  VANUATU: { alphaTwo: 'VU', alphaThree: 'VUT', numeric: '548' },
  VENEZUELA: { alphaTwo: 'VE', alphaThree: 'VEN', numeric: '862' },
  VIETNAM: { alphaTwo: 'VN', alphaThree: 'VNM', numeric: '704' },
  VIRGIN_ISLANDS_BRITISH: { alphaTwo: 'VG', alphaThree: 'VGB', numeric: '092' },
  VIRGIN_ISLANDS_US: { alphaTwo: 'VI', alphaThree: 'VIR', numeric: '850' },
  WALLIS_AND_FUTUNA: { alphaTwo: 'WF', alphaThree: 'WLF', numeric: '876' },
  WESTERN_SAHARA: { alphaTwo: 'EH', alphaThree: 'ESH', numeric: '732' },
  YEMEN: { alphaTwo: 'YE', alphaThree: 'YEM', numeric: '887' },
  ZAMBIA: { alphaTwo: 'ZM', alphaThree: 'ZMB', numeric: '894' },
  ZIMBABWE: { alphaTwo: 'ZW', alphaThree: 'ZWE', numeric: '716' },
  ALAND_ISLANDS: { alphaTwo: 'AX', alphaThree: 'ALA', numeric: '248' },
  BONAIRE_SINT_EUSTATIUS_AND_SABA: { alphaTwo: 'BQ', alphaThree: 'BES', numeric: '535' },
  CURACAO: { alphaTwo: 'CW', alphaThree: 'CUW', numeric: '531' },
  GUERNSEY: { alphaTwo: 'GG', alphaThree: 'GGY', numeric: '831' },
  ISLE_OF_MAN: { alphaTwo: 'IM', alphaThree: 'IMN', numeric: '833' },
  JERSEY: { alphaTwo: 'JE', alphaThree: 'JEY', numeric: '832' },
  MONTENEGRO: { alphaTwo: 'ME', alphaThree: 'MNE', numeric: '499' },
  SAINT_BARTHELEMY: { alphaTwo: 'BL', alphaThree: 'BLM', numeric: '652' },
  SAINT_MARTIN_FRANCE: { alphaTwo: 'MF', alphaThree: 'MAF', numeric: '663' },
  SINT_MAARTEN_DUTCH: { alphaTwo: 'SX', alphaThree: 'SXM', numeric: '534' },
  SOUTH_SUDAN: { alphaTwo: 'SS', alphaThree: 'SSD', numeric: '728' },
  KOSOVO: { alphaTwo: 'XK', alphaThree: 'XKX', numeric: '' },
};
